<template>
  <div class="modal">
    <div class="dialog">
      <header>
        <h2>Edit Media</h2>
      </header>
      <form class="form" @submit.prevent="update">
        <div class="fields">
          <div class="field">
            <label>Type</label>
            <select v-model="medium.type" required>
              <option value="audio">Audio</option>
              <option value="video">Video</option>
              <option value="divider">Divider</option>
              <option value="image">Image</option>
              <option value="link">Link</option>
            </select>
          </div>
          <div class="field">
            <label>Title</label>
            <input type="text" v-model="medium.title" required />
          </div>
          <div class="field" v-if="medium.type === 'link'">
            <label>Link</label>
            <input type="text" v-model="medium.link" required />
          </div>
          <div class="field" v-if="hasUpload">
            <label>File</label>
            <input type="file" @change="uploadFile" v-if="!medium.src && !progress" required />
            <progress v-else-if="progress" max="100" :value="progress" />
            <div v-else class="preview">
              <button @click="removeFile">
                <div class="dashicons dashicons-no" />  
              </button>
              <audio :src="medium.src" v-if="medium.type === 'audio'" ref="preview" controls />
              <video :src="medium.src" v-if="medium.type === 'video'" ref="preview" controls />
              <img :src="medium.src" v-if="medium.type === 'image'" />
            </div>
          </div>
          <div class="field" v-if="hasVolume">
            <label>Volume</label>
            <input type="range" v-model="medium.volume" min="0" max="1" step="0.01" />
          </div>
          <div class="field">
            <label>Color</label>
            <select v-model="medium.color">
              <option></option>
              <option value="red">red</option>
              <option value="orange">orange</option>
              <option value="yellow">yellow</option>
              <option value="green">green</option>
              <option value="cyan">cyan</option>
              <option value="blue">blue</option>
              <option value="paleblue">paleblue</option>
              <option value="purple">purple</option>
              <option value="brown">brown</option>
              <option value="pink">pink</option>
              <option value="violet">violet</option>
            </select>
          </div>
          <div class="field">
            <label>Order</label>
            <input type="number" v-model="medium.order" />
          </div>
        </div>
        <div class="actions">
          <button @click.prevent="cancel">Cancel</button>
          <button class="button">Update</button>
        </div>
      </form>
    </div>
    <div class="scrim" @click="cancel" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { storage } from '@/plugins/db'

export default {
  data: () => ({
    progress: null,
    medium: null,
    id: null
  }),
  props: {
    total: Number,
    reset: Object
  },
  created() {
    this.medium = {...this.reset}
    this.id = this.reset.id
  },
  computed: {
    src() {
      if (this.medium) return this.medium.src
      return false
    },
    volume() {
      if (this.medium) return this.medium.volume
      return false
    },
    hasUpload() {
      return this.medium.type === 'audio' || this.medium.type === 'video' || this.medium.type === 'image'
    },
    hasVolume() {
      return this.medium.type === 'audio' || this.medium.type === 'video'
    }
  },
  watch: {
    volume(val) {
      this.$refs.preview.volume = val
    },
    src(val) {
      if (val) this.$refs.preview.volume = this.volume
    }
  },
  methods: {
    cancel() {
      this.medium = this.reset
      this.$parent.editing = false
    },
    update() {
      this.updateMedia({medium: this.medium, id: this.id})
        .then(() => {
          this.$parent.editing = false
        })
    },
    uploadFile(e) {
      const file = e.target.files[0]
      const meta = { contentType: file.type }
      const ref = `media/${file.name}`
      const task = storage.ref(ref).put(file, meta)
      task.on('state_changed', (snapshot) => {
        this.progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      })
      task
        .then(snapshot => snapshot.ref.getDownloadURL())
        .then((url) => {
          this.progress = null
          this.medium.src = url
          this.medium.ref = ref
        })
        .catch(console.error)
    },
    removeFile() {
      this.medium.src = null
    },
    ...mapActions([
      'updateMedia'
    ])
  }
}
</script>

<style lang="stylus">
</style>
